// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","credits":"Footer_credits__rnvw0","contact":"Footer_contact__WmEl1","copyright":"Footer_copyright__JQMtz"};